import React, {useEffect} from "react";
import useCreateTest from "../hooks/useCreateTest";
import {FormProvider, useForm} from "react-hook-form";
import {IFormCreateTestTraining} from "../components/_interfaces";
import {yupResolver} from "@hookform/resolvers/yup";
import {testTrainingSchema} from "../components/_schemas";
import Box from "@mui/material/Box";
import Loading from "shared/ui/Loading";
import TestConfigMultipleClassrooms from "../components/TestConfigMultipleClassrooms";
import AddTestButton from "../components/AddTestButton";
import TestPreviewCustomItemsList from "../components/TestPreviewCustomItemsList";
import TestPreviewCustom from "../components/TestPreviewCustom";
import SuccessView from "../components/SuccesView";
import PageTitle from "shared/ui/PageTitle";

const CustomPageTitle = () => (
    <PageTitle>Generează teste proprii pentru mai multe clase</PageTitle>
);

const CreateTestMultipleClassroomsCustom = () => {
    const methods = useForm<IFormCreateTestTraining>({
        resolver: yupResolver(testTrainingSchema),
        shouldUnregister: false,
    });

    const testForm = useCreateTest({
        type: "customTest",
        multipleClassrooms: true,
        setError: methods.setError,
        clearErrors: methods.clearErrors,
    });

    const {
        loading,
        step,
        createTestData,
        errorMessage,
        setErrorMessage,
        successMessage,
        isFormValid,
        submitTest,
        resetFormData,
    } = testForm;

    useEffect(() => {
        if (Object.keys(methods.formState.errors).length === 0) {
            setErrorMessage("");
        }
    }, [createTestData]);


    if (successMessage) {
        return (
            <>
                <CustomPageTitle />
                <SuccessView
                    message={successMessage}
                    onReset={resetFormData}
                />
            </>
        );
    }

    if (loading.loading && loading.name === "step") {
        return (
            <>
                <CustomPageTitle />
                <Box width="100%">
                    <Loading show={true} />
                </Box>
            </>
        );
    }

    const renderStepContent = () => {
        switch (step) {
            case 1:
                return (
                    <TestConfigMultipleClassrooms
                        type="customTest"
                        subjects={testForm.subjects}
                        grades={testForm.grades}
                        createTestData={createTestData}
                        setClassroomsHandler={testForm.setClassroomsHandler}
                        getSelectedClassrooms={testForm.getSelectedClassrooms}
                        setSelectedStudentsHandler={testForm.setSelectedStudentsHandler}
                        handleSelectChange={testForm.handleSelectChange}
                        handleInputChange={testForm.handleInputChange}
                        setSubjectHandler={testForm.setSubjectHandler}
                        setGradeHandler={testForm.setGradeHandler}
                        handleTestStartDate={testForm.handleTestStartDateMultipleClassrooms}
                        setTeacherHandler={testForm.setTeacherHandler}
                        setSelectedClassroomsStudentsHandler={testForm.setSelectedClassroomsStudentsHandler}
                        loading={loading}
                        errors={methods.formState.errors}
                        tags={testForm.tags}
                    />
                );
            case 2:
                return (
                    <TestPreviewCustomItemsList
                        createTestData={createTestData}
                        setCustomItemsHandler={testForm.setCustomItemsHandler}
                        removeCustomItemHandler={testForm.removeCustomItemHandler}
                        setSelectedCategoryCustomTestHandler={testForm.setSelectedCategoryCustomTestHandler}
                        selectedItems={testForm.items}
                    />
                );
            case 3:
                return (
                    <TestPreviewCustom
                        items={testForm.items}
                        removeCustomItemHandler={testForm.removeCustomItemHandler}
                    />
                );
            default:
                return null;
        }
    };

    return (
        <>
            <CustomPageTitle />
            <Box width="100%">
                <FormProvider {...methods}>
                    <form onSubmit={methods.handleSubmit(submitTest)} noValidate>
                        <Box mb={{xs: 5, md: 3}}>
                            {renderStepContent()}
                        </Box>
                        {isFormValid && (
                            <AddTestButton
                                errorMessage={errorMessage}
                                step={step}
                                hasSteps={true}
                                totalSteps={3}
                                itemsLength={testForm.items.length}
                                confirmPreviousStep={testForm.confirmPreviousStep}
                            />
                        )}
                    </form>
                </FormProvider>
            </Box>
        </>
    )
}

export default CreateTestMultipleClassroomsCustom;